import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="a3-mail"
export default class extends Controller {
  connect() {
  }
}
